import { render, staticRenderFns } from "./storagePage.vue?vue&type=template&id=b52072c2&"
import script from "./storagePage.vue?vue&type=script&lang=js&"
export * from "./storagePage.vue?vue&type=script&lang=js&"
import style0 from "./storagePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports